<template>
    <div class="modal fade text-left" id="credit_analysis_modal_update" tabindex="-1" role="dialog" aria-labelledby="credit_analysis_label" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                </div>
                <div class="modal-body pb-5 px-sm-4 mx-50" v-if="userStore.userDashboard.creditScores">
                        <div v-if="userStore.userDashboard.creditScores.length > 0">
                        <h1 class="address-title text-center mb-1" id="addNewAddressTitle">Credit Analysis Report</h1>
                        <p class="address-subtitle text-center mb-2 pb-75">{{ localizationStore.translate("report.credit.analysis."+userStore.userDashboard.creditScores[0].type) }}</p>
                        <div class="d-flex justify-content-center align-items-center">
                            <button class="btn btn-primary" @click="downloadCreditAnalysisReport">Export As PDF</button>
                        </div>
                        <!-- Modern Horizontal Wizard -->
                        <section class="modern-horizontal-wizard mt-2">
                            <div class="bs-stepper wizard-modern modern-wizard-example">
                            <div class="bs-stepper-header mx-auto">
                                <div class="step" data-target="#account-details-modern" role="tab" id="account-details-modern-trigger" @click="activateTabs('account_details_modern')" ref="account_details_modern_trigger">
                                    <button type="button" class="step-trigger">
                                        <span class="bs-stepper-box">
                                            <i data-feather="smile" class="font-medium-3"></i>
                                        </span>
                                        <span class="bs-stepper-label">
                                            <span class="bs-stepper-title">Welcome</span>
                                            <span class="bs-stepper-subtitle">Creditfixrr</span>
                                        </span>
                                    </button>
                                </div>
                                <div class="line">
                                    <i data-feather="chevron-right" class="font-medium-2"></i>
                                </div>
                                <div class="step" data-target="#social-links-modern" role="tab" id="social-links-modern-trigger" ref="social_links_modern_trigger" @click="activateTabs('social_links_modern')">
                                    <button type="button" class="step-trigger">
                                    <span class="bs-stepper-box">
                                        <i data-feather="activity" class="font-medium-3"></i>
                                    </span>
                                    <span class="bs-stepper-label">
                                        <span class="bs-stepper-title">Credit Analysis Breakdown</span>
                                        <span class="bs-stepper-subtitle">SmartCredit Credit Report.</span>
                                    </span>
                                    </button>
                                </div>
                                <div class="line">
                                    <i data-feather="chevron-right" class="font-medium-2"></i>
                                </div>
                                <div class="step" data-target="#personal-info-modern" role="tab" id="personal-info-modern-trigger" ref="personal_info_modern_trigger" @click="activateTabs('personal_info_modern')">
                                    <button type="button" class="step-trigger">
                                    <span class="bs-stepper-box">
                                        <i data-feather="file-text" class="font-medium-3"></i>
                                    </span>
                                    <span class="bs-stepper-label">
                                        <span class="bs-stepper-title">Credit Scores Basics</span>
                                        <span class="bs-stepper-subtitle">What You Need to Know</span>
                                    </span>
                                    </button>
                                </div>
                                <div class="line">
                                    <i data-feather="chevron-right" class="font-medium-2"></i>
                                </div>
                                <div class="step" data-target="#address-step-modern" role="tab" id="address-step-modern-trigger" ref="address_step_modern_trigger" @click="activateTabs('address_step_modern')">
                                    <button type="button" class="step-trigger">
                                    <span class="bs-stepper-box">
                                        <i data-feather="bar-chart" class="font-medium-3"></i>
                                    </span>
                                    <span class="bs-stepper-label">
                                        <span class="bs-stepper-title">Credit Score Ranges & Their Meaning</span>
                                        <span class="bs-stepper-subtitle">What You Need to Know</span>
                                    </span>
                                    </button>
                                </div>
                                <div class="line">
                                    <i data-feather="chevron-right" class="font-medium-2"></i>
                                </div>
                                
                                <!-- last step toggle -->
                                <div class="step" data-target="#part-in-the-process" role="tab" id="part-in-the-process-trigger" ref="part_in_the_process_trigger" @click="activateTabs('part_in_the_process')">
                                    <button type="button" class="step-trigger">
                                    <span class="bs-stepper-box">
                                        <i data-feather="award" class="font-medium-3"></i>
                                    </span>
                                    <span class="bs-stepper-label">
                                        <span class="bs-stepper-title">Your Part in the Process</span>
                                        <span class="bs-stepper-subtitle">What You Must Do</span>
                                    </span>
                                    </button>
                                </div>
                                <!-- end of last step -->
                            </div>
                                <!-- Add Step One -->
                                <div class="bs-stepper-content">
                                <div id="account-details-modern" class="content" role="tabpanel" aria-labelledby="account-details-modern-trigger" ref="account_details_modern">
                                    <div class="content-header mx-auto mt-3 mb-1">
                                        <h5 class="mb-0 text-primary">Hey {{ userStore.user.firstname }}!</h5>
                                    </div>
                                    <div class="row">
                                        <div class="mb-1 col-12 mx-auto">
                                            <div>
                                                <p>
                                                    Here is your Full Credit Analysis Report.
                                                    <br>
                                                    Your credit analysis report provides an overview of your most recent credit report as of the last 30 days.
                                                    It lists the items that are negatively affecting your credit scores.
                                                </p>


                                                <p>Your credit analysis report is broken down into the following 4 sections:</p>
                                                <ol style="list-style-type: numeric;" class="ml-1">
                                                    <li>Credit Score Basics.</li>
                                                    <li>Credit Score Ranges and Their Meaning.</li>
                                                    <li>Credit Analysis Breakdown.</li>
                                                    <li>Your Part In The Process.</li>
                                                </ol>

                                                <p>{{ userStore.user.firstname }}, thank you again for entrusting Creditfixrr to assist you in managing and restoring your credit. </p>

                                                <p class="text-primary">Remember You Are The Creditfixrr!</p>
                                                <br>
                                                <p>Best,</p>
                                                <p>The Creditfixrr Team</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- End Of Step One -->
                                <div id="personal-info-modern" class="content" role="tabpanel" aria-labelledby="personal-info-modern-trigger" ref="personal_info_modern">
                                    <div class="content-header mx-auto mt-3 mb-1">
                                    <h4 class="mb-0 text-primary">What Is A Credit Score?</h4>
                                    <!-- <small>Enter Your Personal Info.</small> -->
                                    </div>
                                    <div class="row">

                                        <div class="mb-1 col-12 mx-auto">
                                            <p>
                                                A credit score is a number generated by a mathematical formula that is meant to predict creditworthiness.
                                                Credit scores range from 300-850.
                                                <br>
                                                The higher your score is, the more likely you are to get a loan. The lower
                                                your score is, the less likely you are to get a loan. If you have a low credit score and manage to get approved
                                                for credit, your interest rate will be much higher than someone who had a good credit score. So, having a high
                                                credit score will save you many thousands of dollars.
                                            </p>
                                            <h4 class="mb-0 text-primary">What Is A Credit Score?</h4>
                                            <p>
                                                A credit bureau is a company that collects and maintains your credit information and sells it to lenders, creditors
                                                and consumers in the form of a credit report. There are dozens of credit bureaus, we're most concerned with
                                                the big three: Equifax, Experian, and TransUnion.
                                            </p>
                                            <h4 class="mb-0 text-primary">How Credit Bureaus Determine your Credit Score</h4>

                                            <ul style="list-style-type:circle;" class="ml-2">
                                                <li>Payment History - 35% (on-time payments vs. delinquencies, more weight on the last 24 months)</li>
                                                <li>Utilization and Amount Owed - 30% (percentage of credit limits available)</li>
                                                <li>Length of Credit - 15% (how long you've had your accounts)</li>
                                                <li>Diversity of Credit Used - 10% (installment loans vs. revolving)</li>
                                                <li>Inquiries Credit - 10% (number of inquiries and new accounts opened in the last 12-18 months)</li>
                                            </ul>

                                            <h4 class="mb-0 text-primary">How Your Behavior Is Evaluated In Your Credit Report:</h4>

                                            <p>
                                                Do you pay your bills on time? Payment history is a major factor in credit scoring. If you have paid bills late,
                                                have collections or a bankruptcy, these events won't reflect well in your credit score.
                                            </p>

                                            <p>
                                                Do you have a long credit history? Generally speaking, the longer your history of holding accounts is, the
                                                more trusted you will be as a borrower.
                                            </p>

                                            <p>
                                                Have you applied for credit recently? If you have many recent inquiries this can be construed as being
                                                negative by the bureaus. Only apply for credit when you really want it.
                                            </p>
                                            <p>
                                                What is your outstanding debt? It is important to not use all of your available credit. If all of your credit cards
                                                are maxed out, your scores will reflect that you are not managing your debt wisely.
                                            </p>
                                        </div>

                                    </div>
                                </div>


                                <div id="address-step-modern" class="content" role="tabpanel" aria-labelledby="address-step-modern-trigger" ref="address_step_modern">
                                    <div class="content-header mx-auto mt-3 mb-1">
                                    <h4 class="mb-0 text-primary">Credit Score Ranges And Their Meaning</h4>
                                    <!-- <small>Enter Your Address.</small> -->
                                    </div>
                                    <div class="row">
                                        <div class="mb-1 col-12 mx-auto">
                                            <p>
                                                <span class="text-primary">800 and Higher (Excellent)</span> <br>With a credit score in this range no lender will ever disapprove your loan
                                                application. Additionally, the APR (Annual Percentage Rate) on your credit cards will be the lowest possible.
                                                You'll be treated as royalty. Achieving this excellent credit rating not only requires financial knowledge and
                                                discipline, but also a good credit history. Generally speaking, to achieve this excellent rating you must also use
                                                a substantial amount of credit on an ongoing monthly basis and always repay it ahead of time.
                                            </p>

                                            <p>
                                                <span class="text-success">700 - 799 (Very Good) </span> <br>27% of the United States population belongs to this credit score range. With this credit
                                                score range, you will enjoy good rates and approved for nearly any type of credit loan or personal loan, whether
                                                unsecured or secured.
                                            </p>

                                            <p>
                                                <span style="color:#ffc107">680 - 699 (Good)</span> <br>This range is the average credit score. In this range approvals are practically guaranteed but
                                                the interest rates might be marginally higher. If you're thinking about a long term loan such as a mortgage, try
                                                working to increase your credit score higher than 720 and you will be rewarded for your efforts; your long term
                                                savings will be noticeable.
                                            </p>

                                            <p>
                                            <span class="text-warning">620 - 679 (OK or Fair)</span> <br>Depending on what kind of loan or credit you are applying for and your credit history, you
                                            might find that the rates you are quoted aren't best. That doesn't mean that you won't be approved but, certain
                                            restrictions will apply to the loan's terms.</p>

                                            <p>
                                                <span class="text-danger">580 - 619 (Poor)</span> <br> With a poor credit rating you can still get an unsecured personal loan and even a mortgage,
                                                but the terms and interest rates won't be very appealing. You'll be required to pay more over a longer period of
                                                time because of the high interest rates.
                                            </p>

                                            <p>
                                                <span style="color:#9933CC">500 - 579 (Bad)</span> <br>With a score in this range you can get a loan but nothing even close to what you expect it to be.
                                                Some people with bad credit apply for loans to consolidate debt in search for a fresh start. However, if you
                                                decide to do that proceed cautiously. With a 500 credit score you need to make sure that you don't default on
                                                payments or you'll be making your situation worse and might head towards bankruptcy, which is not what you
                                                want.
                                            </p>

                                            <p>
                                                <span class="text-info">499 and Lower (Very Bad)</span> <br>If this is your score range you need serious assistance with how you handle your
                                                credit. You're making too many credit blunders and they will only get worse if you don't take positive action. If
                                                you are thinking of a loan (which won't be easy), the rates will be very high and the terms will be very strict. We
                                                recommend that you fix your credit first before applying for a loan.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div id="social-links-modern" class="content" role="tabpanel" aria-labelledby="social-links-modern-trigger" ref="social_links_modern">
                                    <div class="content-header ">
                                    </div>
                                    <section id="creditanalysis">
                                        
                                        <div class="content-wrapper">
                                            <credit-analysis></credit-analysis>
                                        </div>

                                    </section>
                                </div>

                                <div id="part-in-the-process" class="content" role="tabpanel" aria-labelledby="part-in-the-process-trigger" ref="part_in_the_process">
                                    <div class="content-header  mx-auto mt-3 mb-1">
                                        <h4 class="mb-0 text-primary">Your Part in the Process</h4>
                                        <!-- <small>SmartCredit Credit Report.</small> -->
                                    </div>
                                    <div class="row">
                                        <div class="mb-1 col-12  mx-auto">
                                        <p>Head over to the Dispute Center and Complete each round of your Personalized Dispute Flow.</p>
                                        <p>
                                            <b>Note</b>:Make sure you have correctly input your personal information in Step.
                                            #1 on your Creditfixrr dashboard and make sure you have uploaded a copy of
                                            your Photo ID and Proof of your current address.
                                        </p>
                                        <p>
                                            Note: a copy of the top section of a recent utility bill (or an insurance statement or some other bill)
                                            can be also be used as proof of your current address.
                                        </p>
                                        <h5 class="text-primary">How You Can Speed Up The Process</h5>
                                        <ol style="list-style-type: numeric;" class="ml-1">
                                            <li>Stop applying for credit (Each time you do it lowers your scores.)</li>
                                            <li>Do not close any accounts (This also lowers your score.)</li>
                                            <li>Pay your credit cards down to below 25% of the available credit line. This will make a huge positive impact on your credit score.</li>
                                            <li>Never spend more than 25% of the available credit line, even if you pay the balance off in full each month.</li>
                                        </ol>
                                        <p>
                                            Pay your bills on time! One missed payment will lower your score dramatically and undo all the work we are doing.
                                        </p>
                                        <ol style="list-style-type: numeric;" class="ml-1">
                                            <li >
                                                Keep your credit monitoring account active throughout the credit repair process,
                                                so that you are able to see the changes to your accounts and scores. Be sure to
                                                refresh your report every 30-35days. Before generating your next round of dispute letters.
                                            </li>
                                            <li>
                                                Most importantly, After sending letters to the bureaus. Be sure to open all of your mail and upload any/all
                                                of their replies inside of your Dispute Letter Tracker. This is as simple as taking a photo with your phone
                                                and uploading it to your portal (or attaching to an email).
                                            </li>
                                        </ol>
                                        <h5 class="text-primary">This Process Takes Time</h5>
                                        <p>
                                            Remember, it has taken you years to get your credit into its current state,
                                            so cleaning it up will not happen overnight. We cannot dispute everything
                                            all at once, or the credit bureaus will reject the disputes by marking them
                                            as "frivolous," so we must do this carefully and strategically. It takes 30
                                            to 45 days for bureaus and creditors to respond to each letter, and even more
                                            time for changes to reflect on your reports. A difficult item may take multiple
                                            letters to multiple parties, so patience is key.
                                        </p>

                                        <p>
                                            Thanks to technology (and by logging into our client portal), you'll receive real-time
                                            updates of the work we're doing every step of the way.
                                        </p>
                                        <p>
                                            By following our program and our advice, your credit will improve -- and along the way, we'll
                                            teach you how to maintain your excellent credit long after our work is done.
                                        </p>

                                        <h5 class="text-primary">How quickly will I see the changes?</h5>
                                        <p>
                                            Credit card companies report your balances to the bureaus once per month (each on a different day)
                                            and your credit reports and scores at the credit monitoring company will only update once per month,
                                            therefore it can take upto two months to see this begin to impact your scores.
                                        </p>
                                        <p>
                                            For this reason, it's important to understand that improving your credit scores takes time and a commitment
                                            to change your daily habits and the way you spent money. The good news is that the sooner you can do it, the
                                            sooner your scores will rise.
                                        </p>
                                        <h5 class="text-primary">Our Plan of Action</h5>
                                        <p>
                                            The credit system is flawed, and nearly 80% of all reports have errors that can lower your score. But you have
                                            rights and we know how to use them to your benefit! The law gives you the right to dispute any item on your credit
                                            reports. And if those items cannot be verified, they must be removed. So we will write many letters to the
                                            bureaus. If they can't prove it, they must remove it! And we are very good at this!
                                        </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                            <div ref="downloadContent" style="margin: 26px;" hidden>
                                <div>
                                    <h1 class="address-title text-center mb-1 mt-2" id="addNewAddressTitle">Credit Analysis Report</h1>
                                    <p class="address-subtitle text-center mb-2 pb-75">{{ localizationStore.translate("report.credit.analysis."+userStore.userDashboard.creditScores[0].type) }}</p>
                                    <!-- here is first header -->
                                    <div class="heading" >
                                        <h3 class="bs-stepper-title text-primary">Welcome Creditfixrr</h3>
                                    </div>
                                    <div id="account-details-modern" class="">
                                        <div class="content-header mx-auto mt-3 mb-1">
                                            <h5 class="mb-0 text-primary">Hey {{ userStore.user.firstname }}!</h5>
                                        </div>
                                        <div class="row">
                                            <div class="mb-1 col-12 mx-auto">
                                                <div>
                                                    <p>
                                                        Here is your Full Credit Analysis Report.
                                                        <br>
                                                        Your credit analysis report provides an overview of your most recent credit report as of the last 30 days.
                                                        It lists the items that are negatively affecting your credit scores.
                                                    </p>
    
    
                                                    <p>Your credit analysis report is broken down into the following 4 sections:</p>
                                                    <ol style="list-style-type: numeric;" class="ml-1">
                                                        <li>Credit Score Basics.</li>
                                                        <li>Credit Score Ranges and Their Meaning.</li>
                                                        <li>Credit Analysis Breakdown.</li>
                                                        <li>Your Part In The Process.</li>
                                                    </ol>
    
                                                    <p>{{ userStore.user.firstname }}, thank you again for entrusting Creditfixrr to assist you in managing and restoring your credit. </p>
    
                                                    <p class="text-primary">Remember You Are The Creditfixrr!</p>
                                                    <br>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end -->
                                    <!-- Second section -->
                                    <div class="heading" >
                                        <h3 class="bs-stepper-title text-primary">Credit Analysis Breakdown</h3>
                                        <p>SmartCredit Credit Report.</p>
                                    </div>
                                    <div id="social-links-modern" >
                                        <div class="content-header ">
                                        </div>
                                        <section id="creditanalysis">
                                            
                                            <div class="content-wrapper">
                                                <credit-analysis></credit-analysis>
                                            </div>
    
                                        </section>
                                    </div>
                                    <!-- end -->
                                    <!-- third section -->
                                    <div class="heading" >
                                        <h3 class="bs-stepper-title text-primary">Credit Scores Basics</h3>
                                        <p>What You Need to Know.</p>
                                    </div>
                                    <div id="personal-info-modern" class="" role="tabpanel">
                                        <div class="content-header mx-auto mt-3 mb-1">
                                        <h4 class="mb-0 text-primary">What Is A Credit Score?</h4>
                                        <!-- <small>Enter Your Personal Info.</small> -->
                                        </div>
                                        <div class="row">
    
                                            <div class="mb-1 col-12 mx-auto">
                                                <p>
                                                    A credit score is a number generated by a mathematical formula that is meant to predict creditworthiness.
                                                    Credit scores range from 300-850.
                                                    <br>
                                                    The higher your score is, the more likely you are to get a loan. The lower
                                                    your score is, the less likely you are to get a loan. If you have a low credit score and manage to get approved
                                                    for credit, your interest rate will be much higher than someone who had a good credit score. So, having a high
                                                    credit score will save you many thousands of dollars.
                                                </p>
                                                <h4 class="mb-0 text-primary">What Is A Credit Score?</h4>
                                                <p>
                                                    A credit bureau is a company that collects and maintains your credit information and sells it to lenders, creditors
                                                    and consumers in the form of a credit report. There are dozens of credit bureaus, we're most concerned with
                                                    the big three: Equifax, Experian, and TransUnion.
                                                </p>
                                                <h4 class="mb-0 text-primary">How Credit Bureaus Determine your Credit Score</h4>
    
                                                <ul style="list-style-type:circle;" class="ml-2">
                                                    <li>Payment History - 35% (on-time payments vs. delinquencies, more weight on the last 24 months)</li>
                                                    <li>Utilization and Amount Owed - 30% (percentage of credit limits available)</li>
                                                    <li>Length of Credit - 15% (how long you've had your accounts)</li>
                                                    <li>Diversity of Credit Used - 10% (installment loans vs. revolving)</li>
                                                    <li>Inquiries Credit - 10% (number of inquiries and new accounts opened in the last 12-18 months)</li>
                                                </ul>
    
                                                <h4 class="mb-0 text-primary">How Your Behavior Is Evaluated In Your Credit Report:</h4>
    
                                                <p>
                                                    Do you pay your bills on time? Payment history is a major factor in credit scoring. If you have paid bills late,
                                                    have collections or a bankruptcy, these events won't reflect well in your credit score.
                                                </p>
    
                                                <p>
                                                    Do you have a long credit history? Generally speaking, the longer your history of holding accounts is, the
                                                    more trusted you will be as a borrower.
                                                </p>
    
                                                <p>
                                                    Have you applied for credit recently? If you have many recent inquiries this can be construed as being
                                                    negative by the bureaus. Only apply for credit when you really want it.
                                                </p>
                                                <p>
                                                    What is your outstanding debt? It is important to not use all of your available credit. If all of your credit cards
                                                    are maxed out, your scores will reflect that you are not managing your debt wisely.
                                                </p>
                                            </div>
    
                                        </div>
                                    </div>
                                    <!-- end -->
                                    <!-- forth section -->
                                    <div class="heading" >
                                        <h3 class="bs-stepper-title text-primary">Credit Score Ranges & Their Meaning</h3>
                                        <p>What You Need to Know.</p>
                                    </div>
                                    <div id="address-step-modern" class="" role="tabpanel">
                                        <div class="content-header mx-auto mt-3 mb-1">
                                        <h4 class="mb-0 text-primary">Credit Score Ranges And Their Meaning</h4>
                                        <!-- <small>Enter Your Address.</small> -->
                                        </div>
                                        <div class="row">
                                            <div class="mb-1 col-12 mx-auto">
                                                <p>
                                                    <span class="text-primary">800 and Higher (Excellent)</span> <br>With a credit score in this range no lender will ever disapprove your loan
                                                    application. Additionally, the APR (Annual Percentage Rate) on your credit cards will be the lowest possible.
                                                    You'll be treated as royalty. Achieving this excellent credit rating not only requires financial knowledge and
                                                    discipline, but also a good credit history. Generally speaking, to achieve this excellent rating you must also use
                                                    a substantial amount of credit on an ongoing monthly basis and always repay it ahead of time.
                                                </p>
    
                                                <p>
                                                    <span class="text-success">700 - 799 (Very Good) </span> <br>27% of the United States population belongs to this credit score range. With this credit
                                                    score range, you will enjoy good rates and approved for nearly any type of credit loan or personal loan, whether
                                                    unsecured or secured.
                                                </p>
    
                                                <p>
                                                    <span style="color:#ffc107">680 - 699 (Good)</span> <br>This range is the average credit score. In this range approvals are practically guaranteed but
                                                    the interest rates might be marginally higher. If you're thinking about a long term loan such as a mortgage, try
                                                    working to increase your credit score higher than 720 and you will be rewarded for your efforts; your long term
                                                    savings will be noticeable.
                                                </p>
    
                                                <p>
                                                <span class="text-warning">620 - 679 (OK or Fair)</span> <br>Depending on what kind of loan or credit you are applying for and your credit history, you
                                                might find that the rates you are quoted aren't best. That doesn't mean that you won't be approved but, certain
                                                restrictions will apply to the loan's terms.</p>
    
                                                <p>
                                                    <span class="text-danger">580 - 619 (Poor)</span> <br> With a poor credit rating you can still get an unsecured personal loan and even a mortgage,
                                                    but the terms and interest rates won't be very appealing. You'll be required to pay more over a longer period of
                                                    time because of the high interest rates.
                                                </p>
    
                                                <p>
                                                    <span style="color:#9933CC">500 - 579 (Bad)</span> <br>With a score in this range you can get a loan but nothing even close to what you expect it to be.
                                                    Some people with bad credit apply for loans to consolidate debt in search for a fresh start. However, if you
                                                    decide to do that proceed cautiously. With a 500 credit score you need to make sure that you don't default on
                                                    payments or you'll be making your situation worse and might head towards bankruptcy, which is not what you
                                                    want.
                                                </p>
    
                                                <p>
                                                    <span class="text-info">499 and Lower (Very Bad)</span> <br>If this is your score range you need serious assistance with how you handle your
                                                    credit. You're making too many credit blunders and they will only get worse if you don't take positive action. If
                                                    you are thinking of a loan (which won't be easy), the rates will be very high and the terms will be very strict. We
                                                    recommend that you fix your credit first before applying for a loan.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- end -->
                                    <!-- fifth section -->
                                    <div class="heading" >
                                        <h3 class="bs-stepper-title text-primary">Your Part in the Process</h3>
                                        <p>What You Must Do</p>
                                    </div>
                                    <div id="part-in-the-process" class="" role="tabpanel">
                                        <div class="content-header  mx-auto mt-3 mb-1">
                                            <h4 class="mb-0 text-primary">Your Part in the Process</h4>
                                            <!-- <small>SmartCredit Credit Report.</small> -->
                                        </div>
                                        <div class="row">
                                            <div class="mb-1 col-12  mx-auto">
                                            <p>Head over to the Dispute Center and Complete each round of your Personalized Dispute Flow.</p>
                                            <p>
                                                <b>Note</b>:Make sure you have correctly input your personal information in Step.
                                                #1 on your Creditfixrr dashboard and make sure you have uploaded a copy of
                                                your Photo ID and Proof of your current address.
                                            </p>
                                            <p>
                                                Note: a copy of the top section of a recent utility bill (or an insurance statement or some other bill)
                                                can be also be used as proof of your current address.
                                            </p>
                                            <h5 class="text-primary">How You Can Speed Up The Process</h5>
                                            <ol style="list-style-type: numeric;" class="ml-1">
                                                <li>Stop applying for credit (Each time you do it lowers your scores.)</li>
                                                <li>Do not close any accounts (This also lowers your score.)</li>
                                                <li>Pay your credit cards down to below 25% of the available credit line. This will make a huge positive impact on your credit score.</li>
                                                <li>Never spend more than 25% of the available credit line, even if you pay the balance off in full each month.</li>
                                            </ol>
                                            <p>
                                                Pay your bills on time! One missed payment will lower your score dramatically and undo all the work we are doing.
                                            </p>
                                            <ol style="list-style-type: numeric;" class="ml-1">
                                                <li >
                                                    Keep your credit monitoring account active throughout the credit repair process,
                                                    so that you are able to see the changes to your accounts and scores. Be sure to
                                                    refresh your report every 30-35days. Before generating your next round of dispute letters.
                                                </li>
                                                <li>
                                                    Most importantly, After sending letters to the bureaus. Be sure to open all of your mail and upload any/all
                                                    of their replies inside of your Dispute Letter Tracker. This is as simple as taking a photo with your phone
                                                    and uploading it to your portal (or attaching to an email).
                                                </li>
                                            </ol>
                                            <h5 class="text-primary">This Process Takes Time</h5>
                                            <p>
                                                Remember, it has taken you years to get your credit into its current state,
                                                so cleaning it up will not happen overnight. We cannot dispute everything
                                                all at once, or the credit bureaus will reject the disputes by marking them
                                                as "frivolous," so we must do this carefully and strategically. It takes 30
                                                to 45 days for bureaus and creditors to respond to each letter, and even more
                                                time for changes to reflect on your reports. A difficult item may take multiple
                                                letters to multiple parties, so patience is key.
                                            </p>
    
                                            <p>
                                                Thanks to technology (and by logging into our client portal), you'll receive real-time
                                                updates of the work we're doing every step of the way.
                                            </p>
                                            <p>
                                                By following our program and our advice, your credit will improve -- and along the way, we'll
                                                teach you how to maintain your excellent credit long after our work is done.
                                            </p>
    
                                            <h5 class="text-primary">How quickly will I see the changes?</h5>
                                            <p>
                                                Credit card companies report your balances to the bureaus once per month (each on a different day)
                                                and your credit reports and scores at the credit monitoring company will only update once per month,
                                                therefore it can take upto two months to see this begin to impact your scores.
                                            </p>
                                            <p>
                                                For this reason, it's important to understand that improving your credit scores takes time and a commitment
                                                to change your daily habits and the way you spent money. The good news is that the sooner you can do it, the
                                                sooner your scores will rise.
                                            </p>
                                            <h5 class="text-primary">Our Plan of Action</h5>
                                            <p>
                                                The credit system is flawed, and nearly 80% of all reports have errors that can lower your score. But you have
                                                rights and we know how to use them to your benefit! The law gives you the right to dispute any item on your credit
                                                reports. And if those items cannot be verified, they must be removed. So we will write many letters to the
                                                bureaus. If they can't prove it, they must remove it! And we are very good at this!
                                            </p>
                                            </div>
                                            <br>
                                            <br>
                                            <p>Best,</p><br>
                                            <p>The Creditfixrr Team</p>
                                        </div>
                                    </div>
                                    <!-- end -->
                                </div>
                            </div>
                        </section>
                        <!-- /Modern Horizontal Wizard -->
                        </div>
                        <div v-else>
                            <div class="mx-auto">
                                <h3 class="text-center text-warning mb-1">Oops...Your Credit Report is Missing.</h3>
                                <h6 class=" text-center text-warning mb-2">In order view your Credit Analysis Report, you must import your Credit Report.
                                    <br> If you don't already have a credit report, you can get one by clicking the button below.
                                </h6>
                            </div>
                            <div style="text-align:center;">
                                <a href="https://www.smartcredit.com/?PID=54821" target="_blank" type="submit"
                                    class="btn btn-warning ">
                                    <i data-feather="external-link" class="mr-25"></i> <span>SmartCredit</span>
                                </a>
                            </div>
                        </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script>
import { useLocalizationStore } from '../../../stores/LocalizationStore.js'
import { useUserStore } from '../../../stores/UserStore.js'
import CreditAnalysis  from  './CreditMonitoringServices/CreditAnalysis.vue'
import DownloadCreditAnalysis  from  './CreditMonitoringServices/DownloadCreditAnalysis.vue'
import html2pdf from "html2pdf.js";
import Swal from 'sweetalert2'
import { ref } from 'vue'
export default{
    components:{
        CreditAnalysis,
        DownloadCreditAnalysis
    },
    setup(){
        const account_details_modern = ref(),
        personal_info_modern = ref(),
        address_step_modern = ref(),
        social_links_modern = ref(),
        part_in_the_process = ref(),
        downloadContent = ref();
        return {
            localizationStore:useLocalizationStore(),
            userStore:useUserStore(),
            account_details_modern,
            personal_info_modern,
            address_step_modern,
            social_links_modern,
            part_in_the_process,
            downloadContent
        }
    },
    watch: {
        async 'account_details_modern' (value) {
            const tabTrigger = this.$refs['account_details_modern_trigger'],
            tabActive = this.$refs['account_details_modern'];
            tabTrigger.classList.add('active');
            tabActive.classList.add('active');
        }
    },
    created(){
        if(_.isEmpty(this.userStore.userDashboard)){
            this.userStore.fetchuserDashboard()
        }
        
    },
    methods:{
        activateTabs(val){
            const array = ['account_details_modern','personal_info_modern','address_step_modern','social_links_modern','part_in_the_process']
            array.forEach(element => {
                const tabTrigger = this.$refs[element+'_trigger'],
                tabActive = this.$refs[element];
                if(element == val){
                    tabTrigger.classList.add('active');
                    tabActive.classList.add('active');
                }else{
                    tabTrigger.classList.remove('active');
                    tabActive.classList.remove('active');
                }
            });
        },
        async downloadCreditAnalysisReport(){
            // The HTML content to be converted to PDF
            Swal.fire({
                title: 'Credit Analysis Report',
                html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> PDF is in Progress`,
                showConfirmButton: false,
                allowOutsideClick: false
            });

            const route = this.$router.resolve(
                {
                    name: 'download-credit-analysis-report',
                }
            ).href;
            try {
                const htmlContent = this.$refs.downloadContent.innerHTML;
                const response = await axios.post(route, { html: htmlContent }, { responseType: 'blob' });
                if(response){
                    Swal.close();
                }
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'credit_analysis_download.pdf');
                document.body.appendChild(link);
                link.click();
            } catch (error) {
                console.error('Error converting HTML to PDF:', error);
            }
        }
    }
}
</script>
